import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BusComponent from '../BusComponent';
import DATA_BROWSER_CONFIG from '../../helpers/DataBrowserConfig';
import DataVariablesList from './dataVariables/DataVariablesList';
import MetaVariable from '../../objects/MetaVariable';
import AppConfig from '../../appConfig';

class DataBrowserSearchResult extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            filteredVariables: [],
        };
    }

    componentDidMount() {
        this.filterVariables();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.searchText !== this.props.searchText) {
            this.filterVariables();
        }
    }

    filterVariables = () => {
        const { searchText, dataset } = this.props;

        const datasetVariables = [];

        DATA_BROWSER_CONFIG.groups.forEach(group => {
            group.variables.forEach(variable => {
                const datasetVariable =
                    dataset.tables[variable.table] &&
                    dataset.tables[variable.table].variables &&
                    dataset.tables[variable.table].variables[variable.name]
                        ? dataset.tables[variable.table].variables[variable.name]
                        : null;
                if (datasetVariable) {
                    const metaVariable = new MetaVariable();
                    Object.assign(metaVariable, datasetVariable);
                    // Set the label from the variable definition
                    metaVariable.label = variable.label;
                    datasetVariables.push(metaVariable);
                }
            });
        });

        const filterText = searchText ? searchText.toLowerCase().trim() : '';

        if (filterText && filterText.length > 0) {
            const filterArray = filterText.split(' ');

            const filteredVariables = datasetVariables.filter(variable => {
                const text = variable.getLabel(0, false).toLowerCase();
                let variableLabelContainsFilterString = true;
                for (let i = 0; i < filterArray.length; i += 1) {
                    if (text.indexOf(filterArray[i]) === -1) {
                        variableLabelContainsFilterString = false;
                        break;
                    }
                }
                return variableLabelContainsFilterString;
            });

            this.setState({
                filteredVariables,
            });
        } else {
            this.setState({
                filteredVariables: datasetVariables,
            });
        }
    };

    render() {
        const { className, searchText, mapInstance, currentMetadataSelection, intl } = this.props;
        const { filteredVariables } = this.state;

        const containerClasses = classnames(
            'data-browser__content flex-it column stretch justify-center',
            className,
        );

        if (filteredVariables.length === 0) {
            return (
                <div className={containerClasses}>
                    <div className="data-browser__search-results-empty body-1">
                        <img
                            className="data-browser__search-results-empty__icon"
                            alt="No data"
                            src={`${AppConfig.constants.assetsBaseURL}/svg/dataBrowser/no-data-illustration.svg`}
                        />
                        <div>
                            {intl.formatMessage({ id: 'dataBrowser.noResultsFor' })}
                            <strong>{searchText}</strong>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className={containerClasses}>
                <DataVariablesList
                    variables={filteredVariables}
                    mapInstanceId={mapInstance.id}
                    hasDataFilter={mapInstance.hasDataFilter}
                    currentMetadataSelection={currentMetadataSelection}
                />
            </div>
        );
    }
}

DataBrowserSearchResult.propTypes = {
    className: PropTypes.string,
    dataset: PropTypes.object.isRequired,
    mapInstance: PropTypes.object.isRequired,
    currentMetadataSelection: PropTypes.object.isRequired,
    searchText: PropTypes.string,
    intl: PropTypes.object.isRequired,
};

DataBrowserSearchResult.defaultProps = {
    className: '',
    searchText: '',
};

export default injectIntl(DataBrowserSearchResult);
